module.exports = __webpack_public_path__ + "img/10.61bfbca2.png";